export const getName = (text) => {
  if (!text) return { firstName: '', lastName: '' };
  // replace \n with space, trim, split by space
  const parts = text.replace(/\n/g, ' ').trim().split(' ');
  if (parts.length === 1) {
    return { firstName: parts[0], lastName: '' };
  }
  // get the last word as last name
  const lastName = parts.length > 1 ? parts.pop() : '';
  // join rest all words, trim, replace multiple spaces with single space
  const firstName = parts.join(' ').trim().replace(/\s+/g, ' ') || '';
  return { firstName, lastName };
};
